// extracted by mini-css-extract-plugin
export default {"order":"DetailOrder_order__ci80g","title":"DetailOrder_title__l7Om5","exist":"DetailOrder_exist__VrwOJ"};